import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { MomentRecipientsClassify } from "../../../../../../hooks/use-moment-recipients-classify";
import { PreviewWithSidebarAutocomplete } from "./preview-with-sidebar-autocomplete";

export const PreviewWithSidebarNotify: FC<{
  data: Extract<MomentRecipientsClassify, { type: "notify" }>["data"];
}> = ({ data }) => {
  const text =
    data.recipients.length === 1 ? data.recipients[0] : `${data.recipients.length} recipients`;

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="body2">Select a subject to preview merge tags</Typography>
      <Typography variant="body2" color="textSecondary">
        Message to {text} about subjects in {data.segment_name}
      </Typography>
      <PreviewWithSidebarAutocomplete info={{ type: "notify", data }} />
    </Stack>
  );
};
